import { ModelFilter } from "react3l-common";
import { IdFilter, StringFilter } from "react3l-advanced-filters";
import { ObjectField } from "react3l-decorators";

export class FileTemplateFilter extends ModelFilter {
  @ObjectField(IdFilter)
  public id?: IdFilter = new IdFilter();
  @ObjectField(StringFilter)
  public code?: StringFilter = new StringFilter();
  @ObjectField(StringFilter)
  public name?: StringFilter = new StringFilter();
  @ObjectField(IdFilter)
  public siteId?: IdFilter = new IdFilter();
  @ObjectField(IdFilter)
  public menuId?: IdFilter = new IdFilter();
  @ObjectField(IdFilter)
  public pageId?: IdFilter = new IdFilter();
  @ObjectField(StringFilter)
  public url?: StringFilter = new StringFilter();
  @ObjectField(StringFilter)
  public fileName?: StringFilter = new StringFilter();
  @ObjectField(IdFilter)
  public selfDefineInputId?: IdFilter = new IdFilter();
  @ObjectField(IdFilter)
  public defaultId?: IdFilter = new IdFilter();
  @ObjectField(IdFilter)
  public statusId?: IdFilter = new IdFilter();
}
